import { Button } from "@/components/ui/button";
import { ArrowRight, Sparkles } from "lucide-react";

export function CTASection({ onCreateDesign }: { onCreateDesign: () => void }) {
  return (
    <section className="py-24 px-4 relative overflow-hidden">
      {/* Gradient background */}
      <div className="absolute inset-0 bg-gradient-to-br from-primary/10 via-accent/10 to-background -z-10" />

      <div className="container mx-auto max-w-4xl text-center space-y-6 sm:space-y-8 px-4">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary/10 text-primary text-sm font-medium">
          <Sparkles className="w-4 h-4" />
          <span>Start creating today</span>
        </div>

        <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-balance leading-tight">
          Ready to Create Your Custom <span className="text-primary">Products?</span>
        </h2>

        <p className="text-lg sm:text-xl text-muted-foreground max-w-2xl mx-auto text-pretty">
          Use AI to create custom products in minutes. From stickers to apparel, bring any idea to
          life.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center pt-4">
          <Button
            onClick={onCreateDesign}
            size="lg"
            className="bg-accent hover:bg-accent/90 text-white text-base group"
          >
            Create My First Design Free
            <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" />
          </Button>
        </div>

        <div className="pt-6 sm:pt-8 text-xs sm:text-sm text-muted-foreground">
          No credit card required • Free AI generations to start • Premium quality guaranteed
        </div>
      </div>
    </section>
  );
}
